export default {
  'alternativePayments.title': '其他支付方式',
  'alternativePayments.column.display': '是否显示',
  'alternativePayments.column.name': '名称',
  'alternativePayments.column.foreign_name': '中文名',

  'alternativePayments.create.title': '新建支付方式',
  'alternativePayments.edit.title': '编辑支付方式',

  'alternativePayments.name.required': '名称不能为空',
  'alternativePayments.foreign_name.required': '中文名不能为空',

  'alternativePayments.name.existed': '此名称已存在',
  'alternativePayments.foreign_name.existed': '此中文名已存在',
  'alternativePayments.deletePromotion': '确认要删除此支付方式吗？',
};
